"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportService = void 0;
var _import = require("../controllers/import.controller");
var ImportService = {
  recordImport: {
    importRecordsValidation: _import.config.recordImport + "/preflight",
    validateRecordGivings: _import.config.recordImport + "/giving/preflight",
    validateRecordFyDownload: _import.config.recordImport + "/fy/preflight",
    importRecords: _import.config.recordImport,
    importRecordsFyDownloads: _import.config.recordImport + "/fy",
    updateRecordGivings: _import.config.recordImport + "/giving",
    recordsValidationErrorDownload: _import.config.recordImport + "/error/download",
    recordsFyValidationErrorDownload: _import.config.recordImport + "/fy/error/download",
    downloadRecordGivingErrorSheet: _import.config.recordImport + "/giving/error/download"
  },
  fundImport: {
    importFundsValidation: _import.config.fundImport + "/preflight",
    importFunds: _import.config.fundImport,
    fundsValidationErrorDownload: _import.config.fundImport + "/error/download",
    importFundAssetsValidation: _import.config.fundImport + "/asset/preflight",
    importFundAssets: _import.config.fundImport + "/asset",
    fundAssetsValidationErrorDownload: _import.config.fundImport + "/asset/error/download"
  },
  fundPerformanceImport: {
    importFundPerformancesValidation: _import.config.fundPerformanceImport + "/preflight",
    importFundPerformances: _import.config.fundPerformanceImport,
    fundPerformancesValidationErrorDownload: _import.config.fundPerformanceImport + "/error/download",
    importFundPerformancesFyValidation: _import.config.fundPerformanceImport + "/fy/preflight",
    importFundPerformancesFy: _import.config.fundPerformanceImport + "/fy",
    fundPerformancesFyValidationErrorDownload: _import.config.fundPerformanceImport + "/error/download"
  },
  fundImpactImport: {
    importFundImpactsValidation: _import.config.fundImpactImport + "/preflight",
    importFundImpacts: _import.config.fundImpactImport,
    fundImpactsValidationErrorDownload: _import.config.fundImpactImport + "/error/download",
    importFundImpactsFyDownloadsValidation: _import.config.fundImpactImport + "/fy/preflight",
    importFundImpactsFyDownloads: _import.config.fundImpactImport + "/fy",
    fundImpactsFyDownloadsValidationError: _import.config.fundImpactImport + "/fy/error/download",
    importFundImpactsFyAssetsValidation: _import.config.fundImpactImport + "/fy/asset/preflight",
    importFundImpactsFyAssets: _import.config.fundImpactImport + "/fy/asset",
    fundImpactsFyAssetsValidationError: _import.config.fundImpactImport + "/fy/asset/error/download"
  },
  fundDonorsImport: {
    importFundDonorsValidation: _import.config.fundDonorsImport + "/preflight",
    importFundDonors: _import.config.fundDonorsImport,
    fundDonorsValidationErrorDownload: _import.config.fundDonorsImport + "/error/download"
  },
  fundTypeImport: {
    import: _import.config.fundTypeImport,
    validationErrorDownload: _import.config.fundTypeImport + "/error/download"
  },
  userImport: {
    importUserValidation: _import.config.userImport + "/preflight",
    importUser: _import.config.userImport,
    userValidationErrorDownload: _import.config.userImport + "/error/download"
  },
  tenantImport: {
    importTenantValidation: _import.config.tenantImport + "/preflight",
    importTenant: _import.config.tenantImport,
    tenantValidationErrorDownload: _import.config.tenantImport + "/error/download",
    tenantDataDownload: _import.config.tenantExport + "/tenant-data"
  },
  templateFileImport: {
    download: _import.config.templateFileImport + "/download"
  },
  dataMapImport: {
    validate: _import.config.dataMapImport + "/preflight",
    upload: _import.config.dataMapImport,
    downloadError: _import.config.dataMapImport + "/error/download"
  },
  dataRecipientImport: {
    validate: _import.config.dataRecipientImport + "/preflight",
    upload: _import.config.dataRecipientImport,
    downloadError: _import.config.dataRecipientImport + "/error/download"
  }
};
exports.ImportService = ImportService;